import { render, staticRenderFns } from "./inputItem.vue?vue&type=template&id=4a8b1217"
import script from "./inputItem.vue?vue&type=script&lang=js"
export * from "./inputItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports